import React from 'react'
import BlogPost from './BlogPost'

export default function OrganizeThoughts() {
  return (
    <BlogPost
      translationKey="organizeThoughts"
      seoTitle="I Want to Be Someone Who Organizes Their Thoughts Well | Hyunjin Jae"
      seoDescription="A reflection on the importance of organizing thoughts and finding clarity in the midst of chaos."
      seoKeywords="thoughts, organization, clarity, reflection, personal growth"
      seoTags={['thoughts', 'organization', 'reflection', 'personal growth']}
    />
  )
} 